module.exports = __webpack_public_path__ + "img/Right Front Door.3152de0b.png";